import toast from "react-hot-toast";

const toastMessage = (type, message) => {
  toast[type](message, {
    duration: 2000,
    position: "top-center",
    // Change colors of success/error/loading icon
    iconTheme: {
      secondary: "#fff",
    },
    // Aria
    ariaProps: {
      role: "status",
      "aria-live": "polite",
    },
  });
};


export default toastMessage;